import axios from 'axios'

const public_document_index = {
  namespaced: true,
  state() {
    return {
      search_conditions: {
        document_name: null,
        outline: null,
        file_name: null,
      },
      old_search_conditions: {
        document_name: null,
        outline: null,
        file_name: null,
      },
      paginationStatus: {
        from: null,
        to: null,
        total: null,
        current_page: null,
        last_page: null,
        per_page: null,
      },
      sortStatus: {
        column: null,
        ascending: true,
      },
      publicDocuments: [],
      management_company_id: null,
      errors: {},
    };
  },
  getters: {
    getParameter(state) {
      return {
        ...state.search_conditions,
        sort_attribute: state.sortStatus.column,
        sort_direction: state.sortStatus.ascending ? 'asc' : 'desc',
        page: state.paginationStatus.current_page,
        per_page: state.paginationStatus.per_page,
      };
    },
    getParameterChangePage(state) {
      return {
        ...state.old_search_conditions,
        sort_attribute: state.sortStatus.column,
        sort_direction: state.sortStatus.ascending ? 'asc' : 'desc',
        page: state.paginationStatus.current_page,
        per_page: state.paginationStatus.per_page,
      };
    },
  },
  mutations: {
    setData(state, data) {
      state.publicDocuments = data;
    },
    setIdToBackListDocument(state, payload) {
      state.management_company_id = payload.management_company_id;
    },
    setErrors(state, errors) {
      state.errors = { ...errors };
    },
    resetErrors(state) {
      state.errors = {};
    },
    setSortColumn(state, payload) {
      if (state.sortStatus.column === payload.column) {
        state.sortStatus.ascending = !state.sortStatus.ascending;
      } else {
        state.sortStatus.column = payload.column;
        state.sortStatus.ascending = true;
      }
      state.paginationStatus.current_page = 1;
    },
    setMeta(state, meta) {
      state.paginationStatus = {
        from: meta.from,
        to: meta.to,
        total: meta.total,
        current_page: meta.current_page,
        last_page: meta.last_page,
        per_page: meta.per_page,
      };
    },
    setCurrentPage(state, payload) {
      state.paginationStatus.current_page = payload.value;
    },
    setPerPage(state, payload) {
      state.paginationStatus.per_page = payload.value;
    },
    inputSearchItem(state, payload) {
      if (state.search_conditions[payload.column] !== undefined) {
        state.search_conditions[payload.column] = payload.value;
      }
    },
    resetForms(state) {
      Object.keys(state.search_conditions).forEach((key) => {
        state.search_conditions[key] = null;
      });
    },
    setOldSearchCodition(state, payload) {
      state.old_search_conditions = payload;
    },
  },
  actions: {
    load({ commit, getters }, payload) {
      if (payload.management_company_id === null) {
        commit('resetErrors');
        commit('setData', []);
      } else {
        return new Promise((resolve, reject) => {
          axios.get('/api/documents_management/', { params: { ...getters.getParameter, management_company_id: payload.management_company_id }}).then((response) => {
            commit('resetErrors');
            commit('setIdToBackListDocument', { management_company_id : payload.management_company_id });
            commit('setOldSearchCodition', { 
              document_name: getters.getParameter.document_name,
              outline: getters.getParameter.outline,
              file_name: getters.getParameter.file_name,
            });
            commit('setData', response.data.data);
            commit('setMeta', response.data.meta);
            resolve(true);
          }).catch((error) => {
            let handled = false;
            if (error.response && error.response.status === 422) {
              commit('setErrors', error.response.data.errors);
              handled = true;
            }
            reject(handled);
          });
        });
      }
    },
    changePage({ commit, getters }, payload) {
      if (payload.management_company_id === null) {
        commit('resetErrors');
        commit('setData', []);
      } else {
        return new Promise((resolve, reject) => {
          axios.get('/api/documents_management/', { params: { ...getters.getParameterChangePage, management_company_id: payload.management_company_id }}).then((response) => {
            commit('resetErrors');
            commit('setIdToBackListDocument', { management_company_id : payload.management_company_id });
            commit('setData', response.data.data);
            commit('setMeta', response.data.meta);
            resolve(true);
          }).catch((error) => {
            let handled = false;
            if (error.response && error.response.status === 422) {
              commit('setErrors', error.response.data.errors);
              handled = true;
            }
            reject(handled);
          });
        });
      }
    },
  },
};

export default public_document_index;
